module.exports = __webpack_public_path__ + "img/phone5.32f55104.png";